
import { ParticipantAttribute } from '__generated__/graphql';
import AddressInput, { AddressInputValue } from './Attributes/AddressInput';
import DateOfBirthInput, { DateOfBirthInputValue } from './Attributes/DateOfBirthInput';
import GenderInput, { GenderInputValue } from './Attributes/GenderInput';
import NationalityInput, { NationalityInputValue } from './Attributes/NationalityInput';
import ParticipantAttributeInputProps from './ParticipantAttributeInputProps';
import PhoneInput, { PhoneInputValue } from './Attributes/PhoneInput';

type ParticipantInputValue = AddressInputValue
& DateOfBirthInputValue
& NationalityInputValue
& PhoneInputValue
& GenderInputValue
& PhoneInputValue;

const ParticipantAttributeInput = (props: ParticipantAttributeInputProps<ParticipantInputValue>) => (
  <>
    {props.attribute === ParticipantAttribute.address && <AddressInput {...props} />}
    {props.attribute === ParticipantAttribute.date_of_birth && <DateOfBirthInput {...props} />}
    {props.attribute === ParticipantAttribute.nationality && <NationalityInput {...props} />}
    {props.attribute === ParticipantAttribute.emergency_phone && <PhoneInput {...props} />}
    {props.attribute === ParticipantAttribute.gender && <GenderInput {...props} />}
    {props.attribute === ParticipantAttribute.phone && <PhoneInput {...props} />}
  </>
);

export default ParticipantAttributeInput;
